import React from 'react';

const HighRiskFormsDetail = ({ highRiskForms }) => {
  if (!highRiskForms) return null;

  const renderYesNo = (value) => {
    if (value === true || value === 'Ya') return <span className="text-green-600 font-medium">✓ Ya</span>;
    if (value === false || value === 'Tidak') return <span className="text-red-600 font-medium">✗ Tidak</span>;
    return <span className="text-gray-500">{value || '-'}</span>;
  };

  const renderBooleanField = (value, trueLabel = 'Ya', falseLabel = 'Tidak') => {
    if (value === true) return <span className="text-green-600 font-medium">✓ {trueLabel}</span>;
    if (value === false) return <span className="text-red-600 font-medium">✗ {falseLabel}</span>;
    return <span className="text-gray-500">-</span>;
  };

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h2 className="text-xl font-semibold text-gray-800 mb-4">Detail High Risk Forms</h2>

      {/* Working at Height */}
      {highRiskForms.working_at_height && (
        <div className="mb-6 p-4 border border-blue-200 rounded-lg bg-blue-50">
          <h3 className="text-lg font-semibold text-blue-800 mb-3">🏗️ WORKING AT HEIGHT PERMIT</h3>
          
          {/* Section 2: Power Supply */}
          <div className="mb-4">
            <h4 className="font-medium text-gray-700 mb-2">2. Pengecekan Instalasi Listrik/Power Supply</h4>
            <div className="grid grid-cols-2 gap-2 text-sm ml-4">
              <p>Area bebas dari listrik: {renderYesNo(highRiskForms.working_at_height.power_supply_area_clear)}</p>
              {highRiskForms.working_at_height.power_supply_notes && (
                <p className="col-span-2">Catatan: {highRiskForms.working_at_height.power_supply_notes}</p>
              )}
            </div>
          </div>

          {/* Section 3: Ladder Check */}
          <div className="mb-4">
            <h4 className="font-medium text-gray-700 mb-2">3. Pengecekan Alat Bantu Tangga/Ladders</h4>
            <div className="grid grid-cols-2 gap-2 text-sm ml-4">
              <p>Kondisi tangga baik: {renderYesNo(highRiskForms.working_at_height.ladder_condition_good)}</p>
              <p>Area aman untuk bergerak: {renderYesNo(highRiskForms.working_at_height.area_safe_movement)}</p>
              <p>Tangga aluminium di area listrik: {renderYesNo(highRiskForms.working_at_height.aluminum_ladder_electric_area)}</p>
              <p>Equipment belt terpasang: {renderYesNo(highRiskForms.working_at_height.equipment_belt_attached)}</p>
              <p>Tangga pedestrian positioned: {renderYesNo(highRiskForms.working_at_height.ladder_pedestrian_positioned)}</p>
              <p>Kunci tangga terpasang: {renderYesNo(highRiskForms.working_at_height.ladder_lock_secured)}</p>
              <p>Ekstensi tangga proper: {renderYesNo(highRiskForms.working_at_height.ladder_extension_proper)}</p>
              {highRiskForms.working_at_height.ladder_notes && (
                <p className="col-span-2">Catatan: {highRiskForms.working_at_height.ladder_notes}</p>
              )}
            </div>
          </div>

          {/* Section 4: PPE */}
          <div className="mb-4">
            <h4 className="font-medium text-gray-700 mb-2">4. Alat Pelindung Diri (PPE)</h4>
            <ul className="list-disc list-inside text-sm ml-4">
              {highRiskForms.working_at_height.ppe_safety_belt_harness && <li>Safety Belt/Harness</li>}
              {highRiskForms.working_at_height.ppe_goggles && <li>Goggles</li>}
              {highRiskForms.working_at_height.ppe_gloves && <li>Gloves</li>}
              {highRiskForms.working_at_height.ppe_safety_boots && <li>Safety Boots</li>}
              {highRiskForms.working_at_height.ppe_protective_clothing && <li>Protective Clothing</li>}
              {highRiskForms.working_at_height.ppe_safety_helmet && <li>Safety Helmet</li>}
              {highRiskForms.working_at_height.ppe_other && <li>Lainnya: {highRiskForms.working_at_height.ppe_other}</li>}
            </ul>
          </div>

          {/* Section 5: Forklift & Platform */}
          <div className="mb-4">
            <h4 className="font-medium text-gray-700 mb-2">5. Forklift dan Platform Sementara</h4>
            <div className="grid grid-cols-2 gap-2 text-sm ml-4">
              <p>Forklift/Platform licensed: {renderYesNo(highRiskForms.working_at_height.forklift_platform_licensed)}</p>
              <p>Area forklift bebas listrik: {renderYesNo(highRiskForms.working_at_height.forklift_area_clear_electric)}</p>
              <p>Fall harness digunakan: {renderYesNo(highRiskForms.working_at_height.forklift_fall_harness_used)}</p>
              <p>Mobile platform OSHA compliant: {renderYesNo(highRiskForms.working_at_height.forklift_mobile_platform_osha)}</p>
              <p>Scaffolding OSHA compliant: {renderYesNo(highRiskForms.working_at_height.scaffolding_osha_compliant)}</p>
              <p>Scaffolding toe guard rails: {renderYesNo(highRiskForms.working_at_height.scaffolding_toe_guard_rails)}</p>
              <p>Mobile scaffolding locked: {renderYesNo(highRiskForms.working_at_height.mobile_scaffolding_locked)}</p>
              <p>Outrigger installed: {renderYesNo(highRiskForms.working_at_height.outrigger_installed)}</p>
              <p>Work area bebas listrik: {renderYesNo(highRiskForms.working_at_height.work_area_clear_electric)}</p>
              {highRiskForms.working_at_height.forklift_notes && (
                <p className="col-span-2">Catatan: {highRiskForms.working_at_height.forklift_notes}</p>
              )}
            </div>
          </div>

          {/* Section 6: Precaution */}
          <div className="mb-4">
            <h4 className="font-medium text-gray-700 mb-2">6. Precaution (Pemberitahuan)</h4>
            <div className="text-sm ml-4 space-y-2">
              <p>Barricade terpasang: {renderBooleanField(highRiskForms.working_at_height.precaution_barricade)}</p>
              {highRiskForms.working_at_height.precaution_special_warning && (
                <p><span className="font-medium">Peringatan Khusus:</span> {highRiskForms.working_at_height.precaution_special_warning}</p>
              )}
            </div>
          </div>

          {/* Declaration */}
          <div className="mt-4 p-3 bg-blue-100 rounded">
            <p className="font-medium text-blue-800">
              Disclaimer - Pekerja sudah di-training: {renderBooleanField(highRiskForms.working_at_height.workers_trained_disclaimer)}
            </p>
            <p className="font-medium text-blue-800 mt-2">
              Panduan dipahami: {renderBooleanField(highRiskForms.working_at_height.guidelines_acknowledged)}
            </p>
          </div>
        </div>
      )}

      {/* Hot Work */}
      {highRiskForms.hot_work && (
        <div className="mb-6 p-4 border border-red-200 rounded-lg bg-red-50">
          <h3 className="text-lg font-semibold text-red-800 mb-3">🔥 HOT WORK PERMIT</h3>
          
          {/* Section 1: Work Type */}
          <div className="mb-4">
            <h4 className="font-medium text-gray-700 mb-2">1. Jenis Pekerjaan Hot Works</h4>
            <ul className="list-disc list-inside text-sm ml-4">
              {highRiskForms.hot_work.work_type_welding_brazing && <li>Welding/Brazing</li>}
              {highRiskForms.hot_work.work_type_cutting && <li>Cutting</li>}
              {highRiskForms.hot_work.work_type_grinding && <li>Grinding</li>}
              {highRiskForms.hot_work.work_type_soldering && <li>Soldering</li>}
              {highRiskForms.hot_work.work_type_thawing && <li>Thawing</li>}
            </ul>
          </div>

          {/* Section 2: Checklist */}
          <div className="mb-4">
            <h4 className="font-medium text-gray-700 mb-2">2. Hot Works Checklist</h4>
            <div className="grid grid-cols-2 gap-2 text-sm ml-4">
              <p>Sprinkler/Hydrant: {highRiskForms.hot_work.checklist_sprinkler_hydrant || '-'}</p>
              <p>Kondisi Equipment: {highRiskForms.hot_work.checklist_equipment_condition || '-'}</p>
              <p>Fire Extinguisher: {highRiskForms.hot_work.checklist_fire_extinguisher || '-'}</p>
            </div>
          </div>

          {/* Section 3: Area 12m Clear */}
          <div className="mb-4">
            <h4 className="font-medium text-gray-700 mb-2">3. Area Bebas 12 Meter</h4>
            <div className="grid grid-cols-2 gap-2 text-sm ml-4">
              <p>Material dibersihkan: {renderYesNo(highRiskForms.hot_work.area_12m_material_cleared)}</p>
              <p>Tidak ada bahan explosive: {renderYesNo(highRiskForms.hot_work.area_12m_no_explosive)}</p>
              <p>Lantai terproteksi: {renderYesNo(highRiskForms.hot_work.area_12m_floor_protected)}</p>
              <p>Dinding/opening terproteksi: {renderYesNo(highRiskForms.hot_work.area_12m_walls_openings_protected)}</p>
              <p>Passage ditutup: {renderYesNo(highRiskForms.hot_work.area_12m_passage_closed)}</p>
            </div>
          </div>

          {/* Section 4: Wall/Ceiling */}
          <div className="mb-4">
            <h4 className="font-medium text-gray-700 mb-2">4. Hot Work Dinding/Ceiling/Plafon</h4>
            <div className="grid grid-cols-2 gap-2 text-sm ml-4">
              <p>Dinding combustible: {renderYesNo(highRiskForms.hot_work.wall_ceiling_combustible)}</p>
              <p>Dinding/ceiling terisolasi: {renderYesNo(highRiskForms.hot_work.wall_ceiling_isolated)}</p>
            </div>
          </div>

          {/* Section 5: Confined Space */}
          <div className="mb-4">
            <h4 className="font-medium text-gray-700 mb-2">5. Hot Work Confined Space</h4>
            <div className="grid grid-cols-2 gap-2 text-sm ml-4">
              <p>Space dibersihkan: {renderYesNo(highRiskForms.hot_work.confined_space_cleaned)}</p>
              <p>Container dikosongkan: {renderYesNo(highRiskForms.hot_work.confined_space_container_emptied)}</p>
              <p>Permit digunakan: {renderYesNo(highRiskForms.hot_work.confined_space_permit_used)}</p>
            </div>
          </div>

          {/* Section 6: Monitoring */}
          <div className="mb-4">
            <h4 className="font-medium text-gray-700 mb-2">6. Hot Work Area Monitoring</h4>
            <div className="grid grid-cols-2 gap-2 text-sm ml-4">
              <p>Fire Watch setelah hot work: {renderYesNo(highRiskForms.hot_work.monitoring_fire_watch_2hrs)}</p>
              <p>SHE punya extinguisher: {renderYesNo(highRiskForms.hot_work.monitoring_she_has_extinguisher)}</p>
              <p>SHE ter-training: {renderYesNo(highRiskForms.hot_work.monitoring_she_trained)}</p>
              <p>SHE diperlukan untuk special: {renderYesNo(highRiskForms.hot_work.monitoring_she_required_special)}</p>
            </div>
          </div>

          {/* Section 7: Other */}
          {highRiskForms.hot_work.other_aspects && (
            <div className="mb-4">
              <h4 className="font-medium text-gray-700 mb-2">7. Aspek Lainnya</h4>
              <p className="text-sm ml-4">{highRiskForms.hot_work.other_aspects}</p>
            </div>
          )}

          {/* Declaration */}
          <div className="mt-4 p-3 bg-red-100 rounded">
            <p className="font-medium text-red-800">
              Warning Sign Disclaimer: {renderBooleanField(highRiskForms.hot_work.warning_sign_disclaimer)}
            </p>
          </div>
        </div>
      )}

      {/* Electric Medium Voltage */}
      {highRiskForms.electric_medium_voltage && (
        <div className="mb-6 p-4 border border-yellow-200 rounded-lg bg-yellow-50">
          <h3 className="text-lg font-semibold text-yellow-800 mb-3">⚡ ELECTRIC MEDIUM VOLTAGE PERMIT</h3>
          
          {/* Section 2: Hazard Identification */}
          <div className="mb-4">
            <h4 className="font-medium text-gray-700 mb-2">2. Identifikasi Bahaya</h4>
            <ul className="list-disc list-inside text-sm ml-4">
              {highRiskForms.electric_medium_voltage.hazard_live_mv_busbar && <li>Live MV Busbar</li>}
              {highRiskForms.electric_medium_voltage.hazard_live_incoming_cable && <li>Live Incoming Cable</li>}
              {highRiskForms.electric_medium_voltage.hazard_charged_transformer && <li>Charged Transformer</li>}
              {highRiskForms.electric_medium_voltage.hazard_rain_outdoor && <li>Rain (Outdoor)</li>}
              {highRiskForms.electric_medium_voltage.hazard_wet_floor && <li>Wet Floor</li>}
              {highRiskForms.electric_medium_voltage.hazard_falling_objects && <li>Falling Objects</li>}
              {highRiskForms.electric_medium_voltage.hazard_explosion && <li>Explosion</li>}
              {highRiskForms.electric_medium_voltage.hazard_confined_area && <li>Confined Area</li>}
            </ul>
          </div>

          {/* Section 4: Electrical MV Checklist */}
          <div className="mb-4">
            <h4 className="font-medium text-gray-700 mb-2">4. Electrical Medium Voltage Checklist</h4>
            <div className="grid grid-cols-2 gap-2 text-sm ml-4">
              <p>Outgoing Switch Off: {renderYesNo(highRiskForms.electric_medium_voltage.checklist_outgoing_switch_off)}</p>
              <p>Outgoing Grounded: {renderYesNo(highRiskForms.electric_medium_voltage.checklist_outgoing_grounded)}</p>
              <p>Outgoing Ground Point: {renderYesNo(highRiskForms.electric_medium_voltage.checklist_outgoing_ground_point)}</p>
              <p>Incoming Switch Off: {renderYesNo(highRiskForms.electric_medium_voltage.checklist_incoming_switch_off)}</p>
              <p>Incoming Busbar Grounded: {renderYesNo(highRiskForms.electric_medium_voltage.checklist_incoming_busbar_grounded)}</p>
              <p>Incoming Ground Point: {renderYesNo(highRiskForms.electric_medium_voltage.checklist_incoming_ground_point)}</p>
              <p>Voltmeter Off: {renderYesNo(highRiskForms.electric_medium_voltage.checklist_voltmeter_off)}</p>
              <p>Incoming Breaker LOTO: {renderYesNo(highRiskForms.electric_medium_voltage.checklist_incoming_breaker_loto)}</p>
              <p>Outgoing Breaker LOTO: {renderYesNo(highRiskForms.electric_medium_voltage.checklist_outgoing_breaker_loto)}</p>
              <p>Manual Clamp Grounding: {renderYesNo(highRiskForms.electric_medium_voltage.checklist_manual_clamp_grounding)}</p>
              <p>Incoming Cable Off: {renderYesNo(highRiskForms.electric_medium_voltage.checklist_incoming_cable_off)}</p>
              <p>Transformer Ground OK: {renderYesNo(highRiskForms.electric_medium_voltage.checklist_transformer_ground_ok)}</p>
            </div>
          </div>

          {/* Section 5: Isolation & Energy Elimination */}
          <div className="mb-4">
            <h4 className="font-medium text-gray-700 mb-2">5. Isolasi dan Eliminasi Energi</h4>
            <div className="grid grid-cols-2 gap-2 text-sm ml-4">
              <p>Uniform & Safety Shoes: {renderYesNo(highRiskForms.electric_medium_voltage.isolation_uniform_safety_shoes)}</p>
              <p>Electric Gloves: {renderYesNo(highRiskForms.electric_medium_voltage.isolation_electric_gloves)}</p>
              <p>Safety Glasses: {renderYesNo(highRiskForms.electric_medium_voltage.isolation_safety_glasses)}</p>
              <p>Tools Certified: {renderYesNo(highRiskForms.electric_medium_voltage.isolation_tools_certified)}</p>
              <p>Work at Height Permit: {renderYesNo(highRiskForms.electric_medium_voltage.isolation_work_at_height_permit)}</p>
              <p>Fire Extinguisher ABC: {renderYesNo(highRiskForms.electric_medium_voltage.isolation_fire_extinguisher_abc)}</p>
            </div>
          </div>

          {/* Declaration */}
          <div className="mt-4 p-3 bg-yellow-100 rounded">
            <p className="font-medium text-yellow-800">
              Workers Briefing Disclaimer: {renderBooleanField(highRiskForms.electric_medium_voltage.workers_briefing_disclaimer)}
            </p>
          </div>
        </div>
      )}

      {/* Confined Space */}
      {highRiskForms.confined_space && (
        <div className="mb-6 p-4 border border-purple-200 rounded-lg bg-purple-50">
          <h3 className="text-lg font-semibold text-purple-800 mb-3">🚧 CONFINED SPACE PERMIT</h3>
          
          {/* Section 1: Type */}
          <div className="mb-4">
            <h4 className="font-medium text-gray-700 mb-2">1. Jenis/Deskripsi dari Confined Space</h4>
            <ul className="list-disc list-inside text-sm ml-4">
              {highRiskForms.confined_space.type_storage_vessels && <li>Storage Vessels</li>}
              {highRiskForms.confined_space.type_underground_space && <li>Underground Space</li>}
              {highRiskForms.confined_space.type_shortcut_ladder && <li>Shortcut Ladder</li>}
              {highRiskForms.confined_space.type_silo_drum_mixer && <li>Silo/Drum/Mixer</li>}
              {highRiskForms.confined_space.type_electrical_room && <li>Electrical Room</li>}
              {highRiskForms.confined_space.type_under_roof_space && <li>Under Roof Space</li>}
              {highRiskForms.confined_space.type_bins_special_room && <li>Bins/Special Room</li>}
              {highRiskForms.confined_space.type_other && <li>Lainnya: {highRiskForms.confined_space.type_other}</li>}
            </ul>
          </div>

          {/* Section 2: Work Type */}
          <div className="mb-4">
            <h4 className="font-medium text-gray-700 mb-2">2. Jenis Pekerjaan</h4>
            <ul className="list-disc list-inside text-sm ml-4">
              {highRiskForms.confined_space.work_inspection && <li>Inspection</li>}
              {highRiskForms.confined_space.work_inside_confined && <li>Work Inside Confined Space</li>}
            </ul>
          </div>

          {/* Section 3: Materials */}
          {highRiskForms.confined_space.materials_chemicals && (
            <div className="mb-4">
              <h4 className="font-medium text-gray-700 mb-2">3. Jenis Material atau Bahan Kimia</h4>
              <p className="text-sm ml-4">{highRiskForms.confined_space.materials_chemicals}</p>
            </div>
          )}

          {/* Section 5.1: Atmospheric Hazards */}
          <div className="mb-4">
            <h4 className="font-medium text-gray-700 mb-2">5.1 Hazardous Atmospheric</h4>
            <ul className="list-disc list-inside text-sm ml-4">
              {highRiskForms.confined_space.hazard_atm_flammable && <li>Flammable</li>}
              {highRiskForms.confined_space.hazard_atm_toxic && <li>Toxic</li>}
              {highRiskForms.confined_space.hazard_atm_irritant && <li>Irritant</li>}
              {highRiskForms.confined_space.hazard_atm_corrosive && <li>Corrosive</li>}
              {highRiskForms.confined_space.hazard_atm_oxygen_deficient && <li>Oxygen Deficient</li>}
              {highRiskForms.confined_space.hazard_atm_oxygen_enriched && <li>Oxygen Enriched</li>}
              {highRiskForms.confined_space.hazard_atm_other && <li>Lainnya: {highRiskForms.confined_space.hazard_atm_other}</li>}
            </ul>
          </div>

          {/* Section 5.2: Physical Hazards */}
          <div className="mb-4">
            <h4 className="font-medium text-gray-700 mb-2">5.2 Physical Hazards</h4>
            <ul className="list-disc list-inside text-sm ml-4">
              {highRiskForms.confined_space.hazard_phy_temperature && <li>Temperature</li>}
              {highRiskForms.confined_space.hazard_phy_chemical_absorption && <li>Chemical Absorption</li>}
              {highRiskForms.confined_space.hazard_phy_noise && <li>Noise</li>}
              {highRiskForms.confined_space.hazard_phy_entrapment && <li>Entrapment</li>}
              {highRiskForms.confined_space.hazard_phy_vibration && <li>Vibration</li>}
              {highRiskForms.confined_space.hazard_phy_electrical_equipment && <li>Electrical Equipment</li>}
              {highRiskForms.confined_space.hazard_phy_mechanical_equipment && <li>Mechanical Equipment</li>}
              {highRiskForms.confined_space.hazard_phy_spark_operations && <li>Spark Operations</li>}
              {highRiskForms.confined_space.hazard_phy_spilled_liquids && <li>Spilled Liquids</li>}
              {highRiskForms.confined_space.hazard_phy_engulfment && <li>Engulfment</li>}
              {highRiskForms.confined_space.hazard_phy_radiation && <li>Radiation</li>}
              {highRiskForms.confined_space.hazard_phy_entry_exit_limitation && <li>Entry/Exit Limitation</li>}
              {highRiskForms.confined_space.hazard_phy_other && <li>Lainnya: {highRiskForms.confined_space.hazard_phy_other}</li>}
            </ul>
          </div>

          {/* Section 6: PPE */}
          <div className="mb-4">
            <h4 className="font-medium text-gray-700 mb-2">6. Personal Protective Equipment</h4>
            <div className="grid grid-cols-2 gap-4 text-sm ml-4">
              <div>
                <p className="font-medium">6.1 Respiratory Protection:</p>
                <ul className="list-disc list-inside ml-2">
                  {highRiskForms.confined_space.ppe_resp_scba && <li>SCBA</li>}
                  {highRiskForms.confined_space.ppe_resp_air_purifying && <li>Air Purifying Respirator</li>}
                  {highRiskForms.confined_space.ppe_resp_air_line && <li>Air Line</li>}
                </ul>
              </div>
              <div>
                <p className="font-medium">6.2 Eye Protection:</p>
                <ul className="list-disc list-inside ml-2">
                  {highRiskForms.confined_space.ppe_eye_safety_glasses && <li>Safety Glasses</li>}
                  {highRiskForms.confined_space.ppe_eye_goggles && <li>Goggles</li>}
                </ul>
              </div>
              <div>
                <p className="font-medium">6.3 Routine Protection:</p>
                <ul className="list-disc list-inside ml-2">
                  {highRiskForms.confined_space.ppe_routine_gloves && <li>Gloves</li>}
                  {highRiskForms.confined_space.ppe_routine_chemical_suit && <li>Chemical Suit</li>}
                  {highRiskForms.confined_space.ppe_routine_hard_hat && <li>Hard Hat</li>}
                  {highRiskForms.confined_space.ppe_routine_overall && <li>Overall</li>}
                  {highRiskForms.confined_space.ppe_routine_earplug && <li>Earplug/Muffs</li>}
                  {highRiskForms.confined_space.ppe_routine_safety_boots && <li>Safety Boots</li>}
                </ul>
              </div>
              <div>
                <p className="font-medium">6.4 Rescue/Access Equipment:</p>
                <ul className="list-disc list-inside ml-2">
                  {highRiskForms.confined_space.ppe_rescue_escape_set && <li>Escape Set</li>}
                  {highRiskForms.confined_space.ppe_rescue_communication && <li>Communication (2-Way Radio)</li>}
                  {highRiskForms.confined_space.ppe_rescue_motion_detector && <li>Motion Detector</li>}
                  {highRiskForms.confined_space.ppe_rescue_life_line && <li>Life Line</li>}
                  {highRiskForms.confined_space.ppe_rescue_lifting_gear && <li>Lifting Gear</li>}
                </ul>
              </div>
              <div>
                <p className="font-medium">6.5 Essential Requirement:</p>
                <ul className="list-disc list-inside ml-2">
                  {highRiskForms.confined_space.ppe_essential_fire_extinguisher && <li>Fire Extinguisher</li>}
                  {highRiskForms.confined_space.ppe_essential_first_aid && <li>First Aid Kits</li>}
                  {highRiskForms.confined_space.ppe_essential_torch && <li>Torch</li>}
                </ul>
              </div>
              {highRiskForms.confined_space.ppe_other && (
                <div>
                  <p className="font-medium">6.6 Lainnya:</p>
                  <p className="ml-2">{highRiskForms.confined_space.ppe_other}</p>
                </div>
              )}
            </div>
          </div>

          {/* Section 7: Hot Work */}
          <div className="mb-4">
            <h4 className="font-medium text-gray-700 mb-2">7. Pekerjaan Hot Work</h4>
            <div className="grid grid-cols-2 gap-2 text-sm ml-4">
              <p>Area bebas 15m: {renderYesNo(highRiskForms.confined_space.hot_work_area_clear_15m)}</p>
              <p>Fire Extinguisher tersedia: {renderYesNo(highRiskForms.confined_space.hot_work_fire_extinguisher_available)}</p>
              <p>Tipe Extinguisher: {highRiskForms.confined_space.hot_work_extinguisher_type || '-'}</p>
              <p>Udara bebas gas: {renderYesNo(highRiskForms.confined_space.hot_work_air_free_gas)}</p>
              <p>Entry/Exit aman: {renderYesNo(highRiskForms.confined_space.hot_work_entry_exit_safe)}</p>
              <p>Hot Work ada: {renderYesNo(highRiskForms.confined_space.hot_work_welding_exists)}</p>
            </div>
          </div>

          {/* Section 8: Hot Work Inspection */}
          {highRiskForms.confined_space.hot_work_welding_exists === 'Ya' && (
            <div className="mb-4 p-3 bg-orange-50 border border-orange-200 rounded">
              <h4 className="font-medium text-orange-800 mb-2">8. Inspeksi Pekerjaan Hot Work</h4>
              <div className="grid grid-cols-2 gap-2 text-sm">
                <p>Sertifikat ASME: {renderYesNo(highRiskForms.confined_space.hot_work_cert_asme)}</p>
                {highRiskForms.confined_space.hot_work_cert_other && (
                  <p>Sertifikat lain: {highRiskForms.confined_space.hot_work_cert_other}</p>
                )}
                {highRiskForms.confined_space.hot_work_equipment_list && (
                  <p className="col-span-2">Peralatan: {highRiskForms.confined_space.hot_work_equipment_list}</p>
                )}
                <div className="col-span-2">
                  <p className="font-medium">Jenis Hot Work:</p>
                  <ul className="list-disc list-inside ml-2">
                    {highRiskForms.confined_space.hot_work_type_acetylene && <li>Acetylene Weld</li>}
                    {highRiskForms.confined_space.hot_work_type_arc_welding && <li>Arc Welding</li>}
                    {highRiskForms.confined_space.hot_work_type_oxygen_cutting && <li>Oxygen Cutting/Welding</li>}
                  </ul>
                </div>
                <p>Tabung bersertifikat: {renderYesNo(highRiskForms.confined_space.hot_work_cylinder_certified)}</p>
                <p>Kondisi hose: {highRiskForms.confined_space.hot_work_hose_condition || '-'}</p>
                <p>Kondisi coupling: {highRiskForms.confined_space.hot_work_coupling_condition || '-'}</p>
              </div>
            </div>
          )}

          {/* Section 10: Hazard Controls */}
          <div className="mb-4">
            <h4 className="font-medium text-gray-700 mb-2">10. Hazard Controls</h4>
            <div className="grid grid-cols-2 gap-2 text-sm ml-4">
              <p>LOTO diperlukan: {renderYesNo(highRiskForms.confined_space.control_loto_required)}</p>
              {highRiskForms.confined_space.control_loto_points && (
                <p>Titik LOTO: {highRiskForms.confined_space.control_loto_points}</p>
              )}
              <p>GFCI diperlukan: {renderYesNo(highRiskForms.confined_space.control_gfci_required)}</p>
              <p>Explosion-proof diperlukan: {renderYesNo(highRiskForms.confined_space.control_explosion_proof_required)}</p>
              <p>Barrier diperlukan: {renderYesNo(highRiskForms.confined_space.control_barrier_required)}</p>
              <p>Komunikasi diperlukan: {renderYesNo(highRiskForms.confined_space.control_communication_required)}</p>
              <p>Emergency phone/radio: {renderYesNo(highRiskForms.confined_space.control_emergency_phone_radio)}</p>
              
              {/* Equipment Section */}
              <p className="col-span-2 font-medium mt-2">Equipment:</p>
              <p>Fire Extinguisher: {renderYesNo(highRiskForms.confined_space.control_equipment_fire_extinguisher)}</p>
              <p>Emergency Shower: {renderYesNo(highRiskForms.confined_space.control_equipment_emergency_shower)}</p>
              <p>Safety Harness: {renderYesNo(highRiskForms.confined_space.control_equipment_safety_harness)}</p>
              <p>Life Line: {renderYesNo(highRiskForms.confined_space.control_equipment_life_line)}</p>
              <p>Tripod/Winch: {renderYesNo(highRiskForms.confined_space.control_equipment_tripod_winch)}</p>
              {highRiskForms.confined_space.control_equipment_other && (
                <p className="col-span-2">Equipment Lainnya: {highRiskForms.confined_space.control_equipment_other}</p>
              )}
              
              <p>MSDS dilampirkan: {renderYesNo(highRiskForms.confined_space.control_msds_attached)}</p>
              <p>Pekerja ter-training: {renderYesNo(highRiskForms.confined_space.control_workers_trained)}</p>
              <p>Standby person diberitahu: {renderYesNo(highRiskForms.confined_space.control_standby_notified)}</p>
              <p>Perlu dibersihkan: {renderYesNo(highRiskForms.confined_space.control_space_cleaned)}</p>
              {highRiskForms.confined_space.control_cleaning_method && (
                <p>Metode pembersihan: {highRiskForms.confined_space.control_cleaning_method}</p>
              )}
              <p>Pembersihan melibatkan gas: {renderYesNo(highRiskForms.confined_space.control_cleaning_involves_gas)}</p>
              {highRiskForms.confined_space.control_gas_type && (
                <p>Jenis gas: {highRiskForms.confined_space.control_gas_type}</p>
              )}
              <p>Gas dikosongkan: {renderYesNo(highRiskForms.confined_space.control_space_emptied)}</p>
            </div>
          </div>

          {/* Equipment Declaration */}
          {highRiskForms.confined_space.equipment_declaration && (
            <div className="mb-4 p-3 bg-purple-100 rounded">
              <h4 className="font-medium text-purple-800 mb-2">9. Equipment Declaration</h4>
              <p className="text-sm">{highRiskForms.confined_space.equipment_declaration}</p>
            </div>
          )}

          {/* Declaration */}
          <div className="mt-4 p-3 bg-purple-100 rounded">
            <p className="font-medium text-purple-800">
              Deklarasi - Memahami semua pekerjaan confined space: 
              <span className={highRiskForms.confined_space.declaration_understand_work ? 'text-green-600 ml-2 font-semibold' : 'text-red-600 ml-2 font-semibold'}>
                {renderBooleanField(highRiskForms.confined_space.declaration_understand_work)}
              </span>
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default HighRiskFormsDetail;
